import {
  GetHealthCampDropDownListActionTypes,
  GET_HEALTH_CAMP_DROPDOWN_LIST_FAIL,
  GET_HEALTH_CAMP_DROPDOWN_LIST_LOADING,
  GET_HEALTH_CAMP_DROPDOWN_LIST_SUCCESS,
  GetHealthCampDropDownListState,
  GET_HEALTH_CAMP_DROPDOWN_LIST_UPDATE_API_MSG,
  GET_HEALTH_CAMP_DROPDOWN_LIST_UPDATE_API_RES,
} from "./ActionTypes";
import { GetHealthCampDropDownListRes } from "./Model";

const initialStateGetPosts: GetHealthCampDropDownListState = {
  loading: false,
  getHealthCampDropDownListRes: {} as GetHealthCampDropDownListRes,
  successMsg: "",
  errorMsg: "",
  status: 0,
};
export const getHealthCampDropDownListReducer = (
  state = initialStateGetPosts,
  action: GetHealthCampDropDownListActionTypes
): GetHealthCampDropDownListState => {
  switch (action.type) {
    case GET_HEALTH_CAMP_DROPDOWN_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_HEALTH_CAMP_DROPDOWN_LIST_SUCCESS:
      return {
        ...state,
        getHealthCampDropDownListRes: action.payload,
        successMsg: action.successMsg,
      };
    case GET_HEALTH_CAMP_DROPDOWN_LIST_FAIL:
      return {
        ...state,
        getHealthCampDropDownListRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_HEALTH_CAMP_DROPDOWN_LIST_UPDATE_API_MSG:
      return {
        ...state,
        getHealthCampDropDownListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_HEALTH_CAMP_DROPDOWN_LIST_UPDATE_API_RES:
      return {
        ...state,
        getHealthCampDropDownListRes: action.payload,
        successMsg: action.successMsg,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
